import { render, staticRenderFns } from "./PackoutMessageModal.vue?vue&type=template&id=2397bdcc"
import script from "./PackoutMessageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackoutMessageModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports